import { Table, TableColumnsType, Typography } from 'antd'
import { AdminsUserListResponseItem } from 'generated/api'

interface IProps {
  dataSource: AdminsUserListResponseItem[]
  tableContainerRef: React.MutableRefObject<HTMLDivElement | null>
  selected: AdminsUserListResponseItem[]
  onSelected: (user: AdminsUserListResponseItem) => void
  includeUser: AdminsUserListResponseItem[]
  selectAll: boolean
  excludeUser: AdminsUserListResponseItem[]
  loading: boolean
}

const columns: TableColumnsType<AdminsUserListResponseItem> = [
  {
    title: 'Nama',
    dataIndex: 'name',
    render: data => (
      <div data-testid="cell_name" className="flex flex-col">
        <Typography.Text className="font-medium text-gray-800">
          {data == '' ? '-' : data}
        </Typography.Text>
      </div>
    ),
  },
  {
    title: 'Nomor Telepon',
    dataIndex: 'phoneNo',
    render: data => (
      <div data-testid="cell_phone" className="flex flex-col">
        <Typography.Text className="font-medium text-gray-800">
          {data == '' ? '-' : data}
        </Typography.Text>
      </div>
    ),
  },
]

export default function TableSawitPoinRecevier(props: Readonly<IProps>) {
  const { selectAll, includeUser, excludeUser, dataSource, loading } = props

  const rowSelection = {
    onSelect: (record: AdminsUserListResponseItem) => {
      props.onSelected(record)
    },
    getCheckboxProps: (record: AdminsUserListResponseItem) => ({
      name: record.id,
    }),
  }

  const excludeId = excludeUser.map(res => res.id)

  const selectedUsers = !selectAll
    ? includeUser.map(res => res.id)
    : dataSource.filter(res => !excludeId.includes(res.id)).map(res => res.id)

  return (
    <div ref={props.tableContainerRef} style={{ overflowY: 'auto', maxHeight: '500px' }}>
      <Table
        rowKey="id"
        loading={loading}
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
          selectedRowKeys: selectedUsers,
        }}
        data-testid="table-receiver"
        pagination={false}
        columns={columns}
        dataSource={props.dataSource}
      />
    </div>
  )
}
